module.exports = __webpack_public_path__ + "static/media/J (6).fc5ec6f5.jpg";